import { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import {
    security_key,
    BASE_URL
} from "../global";
import axios from "axios";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";

function ReportCustomEnrolmentReport() {
    const location = useLocation();
    useEffect(() => {
        sessionStorage.setItem("previousPagePathname", location.pathname);
    }, [location.pathname]);

    const [loading, setLoading] = useState(false);
    const [records, setRecords] = useState([]);
    const [columns, setColumns] = useState([]);

    const fetchData = async () => {
        setLoading(true);
        try {
            const response = await axios.post(BASE_URL + "API/api_index.php", {
                security_key: security_key,
                mode: "getCenterCustomEnrollmentReport",
                fk_cent_key: sessionStorage.getItem("key"),
            });

            if (response.data.success === true) {
                const { columns, rows } = transformData(response.data.data);
                setColumns(columns);
                setRecords(rows);
            }
        } catch (err) {
            console.error("Error fetching:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const transformData = (raw) => {
        const grouped = {};
        const questions = [];

        raw.forEach((entry) => {
            const studentKey = `${entry.st_first_name} ${entry.st_surname}`;
            if (!grouped[studentKey]) {
                grouped[studentKey] = {
                    id: studentKey,
                    student_name: studentKey,
                };
            }
            grouped[studentKey][entry.me_question] = entry.ena_answer;
            if (!questions.includes(entry.me_question)) {
                questions.push(entry.me_question);
            }
        });

        const cols = [
            {
                field: "student_name",
                headerName: "Student Name",
                headerClassName: "super-app-theme--header",
                width: 180,
            },
            ...questions.map((q) => ({
                field: q,
                headerName: q,
                headerClassName: "super-app-theme--header",
                width: Math.max(q.length * 8, 200),
            })),
        ];

        return {
            columns: cols,
            rows: Object.values(grouped),
        };
    };

    return (
        <div className="">
            <div className="mb-3 d-flex justify-content-between align-items-center">
                <div>
                    <h5 className="page-title">Custom Enrolment Field Report</h5>
                    <Breadcrumbs aria-label="breadcrumb" className="my-breadcrumbs">
                        <NavLink to="/calendar">Home</NavLink>
                        <NavLink to="/reports">Reports</NavLink>
                        <Typography color="text.primary">Custom Enrolment Field Report</Typography>
                    </Breadcrumbs>
                </div>
            </div>

            <Card className="card my-card mb-3">
                <Card.Body>
                    <Row>
                        <Col xs="12">
                            <Box
                                sx={{
                                    width: "100%",
                                    overflowX: "auto",
                                    "& .super-app-theme--header": {
                                        backgroundColor: "#f4f4f4",
                                        whiteSpace: "normal",
                                    },
                                    "& .MuiDataGrid-columnHeaders": {
                                        minWidth: "fit-content !important",
                                    },
                                    "& .MuiDataGrid-cell": {
                                        whiteSpace: "normal",
                                        wordWrap: "break-word",
                                    },
                                    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus": {
                                        outline: "none",
                                    },
                                }}
                            >
                                <DataGrid
                                    autoHeight
                                    loading={loading}
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                        toolbar: GridToolbar,
                                    }}
                                    slotProps={{
                                        toolbar: {
                                            csvOptions: { fileName: "CustomEnrolmentFieldsReport" },
                                            printOptions: {
                                                pageStyle: `@media print {
                          @page {
                            size: A4 landscape;
                            margin: 0;
                          }
                        }`,
                                                fileName: "CustomEnrolmentFieldsReport",
                                                hideToolbar: true,
                                                hideFooter: true,
                                            },
                                            showQuickFilter: true,
                                        },
                                    }}
                                    initialState={{
                                        pagination: { paginationModel: { pageSize: 10 } },
                                    }}
                                    pageSizeOptions={[10, 25, 50, 100]}
                                    rows={records}
                                    columns={columns}
                                    rowHeight={60}
                                    density="compact"
                                    disableRowSelectionOnClick
                                    showCellVerticalBorder
                                    showColumnVerticalBorder
                                />
                            </Box>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
}

export default ReportCustomEnrolmentReport;
